import React, { useState, useEffect, useContext } from 'react'
import { Link } from 'react-router-dom';
import AdsComponent from '../../components/AdsComponent'
import AdsForm from '../../components/AdsForm'
import Table from '../../components/Table';
import { AuthContext } from '../../context/AuthContext';
import { api } from '../../api/axios';
import { tableDateFormate } from '../../utils/dateHelper';
import { Eye, EyeOff, Trash, Pen, Image } from 'lucide-react';
import { toast } from 'react-toastify';
import { fileUlr } from '../../api/url';
import Modal from '../../components/Modal';
import PaginationBar from '../../components/PaginationBar';

const PAGE_SIZE = 20;

const tableHeadingdata = [
    '#',
    'Name',
    'Note',
    'Date',
    'Action'
]




export default function Ads() {

    const { loading } = useContext(AuthContext);
    const [adsData, setAdsData] = useState([]);
    const [page, setPage] = useState(1);

    const [isEditModalOpen, setIsEditModalOpen] = useState(false)
    const [editAdsData, setEditAdsData] = useState({})

    useEffect(() => {
        handelGetData();

    }, [loading])

    const handelGetData = async () => {
        try {
            const response = await api.get('/ads');
            setAdsData(response.data)
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const handelChangeVisibilityOffAds = async (id, isActive) => {
        try {
            const resposns = await api.patch(`/ads/active/${id}`, { isActive: !isActive })

            if (resposns.status === 200) {
                handelGetData();
                toast.success("Ads Visibility Changed Successfully")
            }
        } catch (error) {
            toast.error("Ads Visibility Changed Error")
            console.log(error);
        }
    }

    const handelDeleteAds = async (id) => {
        if (!window.confirm('Delete this ad? This cannot be undone.')) return;
        try {
            const resposns = await api.delete(`/ads/${id}`)

            if (resposns.status === 200) {
                handelGetData();
                toast.success("Ads Deleted Successfully")
            }

        } catch (error) {
            toast.error("Ads Delete Error")
            console.log(error);
        }
    }

    const handleOpenAdsEditModal = (item) => {
        setEditAdsData(item)
        setIsEditModalOpen(true)
    }

    const handleCloseAdsEditModal = () => {
        setIsEditModalOpen(false)
    }

    const handleSubmitAdsEditForm = async (e) => {
        e.preventDefault();

        const formData = new FormData(e.target);
        const data = Object.fromEntries(formData);
        // console.log(data);

        try {
            const resposns = await api.patch(`/ads/${editAdsData._id}`, data)

            if (resposns.status === 200) {
                handelGetData();
                toast.success("Ads Updated Successfully")
                handleCloseAdsEditModal();
            }

        } catch (error) {
            toast.error("Ads Update Error")
            console.log(error);
        }
    }


    return (
        <>

            <AdsComponent>
                <AdsForm />

                <Table
                    tableHeadingdata={tableHeadingdata}>
                    <>
                        {
                            adsData.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE).map((item, index) => (
                                <tr className="bg-white border-b hover:bg-gray-100 text-gray-900" key={index}>
                                    <th scope="row" className="px-6 py-4 font-medium whitespace-nowrap">
                                        {(page - 1) * PAGE_SIZE + index + 1}
                                    </th>
                                    <td className="px-6 py-4 font-medium whitespace-nowrap">
                                        {item.name}
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        {item.note}
                                    </td>
                                    <td className="px-6 py-4">
                                        {tableDateFormate(item.updatedAt)}
                                    </td>
                                    <td className="px-6 py-4 text-right flex gap-6 justify-center">
                                        <Link
                                            to={`${fileUlr}/uploads/${item.image}`}
                                            target='_blank'
                                            className="font-medium text-purple-400 dark:text-purple-400 dark:hover:text-purple-800 hover:text-purple-800">
                                            <Image />
                                        </Link>

                                        <button
                                            onClick={() => handelChangeVisibilityOffAds(item._id, item.isActive)}
                                            className="font-medium text-gray-400 dark:text-gray-400 dark:hover:text-gray-800 hover:text-gray-800">
                                            {item.isActive ? <Eye /> : <EyeOff />}
                                        </button>
                                        <button
                                            onClick={() => handelDeleteAds(item._id)}
                                            className="font-medium text-red-300 dark:text-red-300 dark:hover:text-red-600 hover:text-red-600">
                                            <Trash />
                                        </button>
                                        <button
                                            onClick={() => handleOpenAdsEditModal(item)}
                                            className="font-medium text-green-300 dark:text-greenblue-300 dark:hover:text-green-600 hover:text-green-600">
                                            <Pen />
                                        </button>
                                    </td>
                                </tr>
                            ))
                        }
                    </>
                </Table>

                <div className="mt-4">
                    <PaginationBar
                        totalItems={adsData.length}
                        page={page}
                        pageSize={PAGE_SIZE}
                        onChange={setPage}
                    />
                </div>

                {
                    isEditModalOpen && <Modal
                        title={"Edit Ads Data"}
                        closeModal={handleCloseAdsEditModal}
                    >
                        <form onSubmit={handleSubmitAdsEditForm} className='grid grid-cols-6 gap-x-4 gap-y-6 w-[50rem]'>
                            <div className="col-span-6">
                                <label htmlFor="updatename" className="block text-sm/6 font-medium text-gray-900">
                                    Name <span className='text-sm text-red-400'>*</span>
                                </label>
                                <div className="mt-3">
                                    <input
                                        id="updatename"
                                        name="name"
                                        type="text"
                                        defaultValue={editAdsData.name}
                                        required={true}
                                        className="px-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm/6"
                                    />
                                </div>
                            </div>
                            <div className="col-span-6">
                                <label htmlFor="updatenote" className="block text-sm/6 font-medium text-gray-900">
                                    Note <span className='text-sm text-red-400'>*</span>
                                </label>
                                <div className="mt-3">
                                    <textarea
                                        id="updatenote"
                                        name="note"
                                        type="text"
                                        defaultValue={editAdsData.note}
                                        required={true}
                                        rows={4}
                                        className="px-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm/6"
                                    ></textarea>
                                </div>
                            </div>
                            <div className="col-span-6 flex justify-center">
                                <button
                                    type="submit"
                                    className="rounded-md bg-green-600 w-full px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
                                >
                                    Update Ads
                                </button>
                            </div>
                        </form>
                    </Modal>
                }

            </AdsComponent>
        </>
    )
}
